<output-form-row [labelId]="'address_panel.first_name'" [value]="firstName()"></output-form-row>
<output-form-row [labelId]="'address_panel.last_name'" [value]="lastName()"></output-form-row>
<output-form-row [labelId]="'address_panel.street'" [value]="street()"></output-form-row>
<output-form-row [labelId]="'address_panel.city'" [value]="city()"></output-form-row>
<output-form-row [labelId]="'address_panel.zip'" [value]="zip()"></output-form-row>
<output-form-row [labelId]="'address_panel.country'" [value]="country()"></output-form-row>
<output-form-row [labelId]="'address_panel.company'" [value]="company()"></output-form-row>
